import { render, staticRenderFns } from "./MgmManage.vue?vue&type=template&id=17be9d2e&scoped=true&"
import script from "./MgmManage.vue?vue&type=script&lang=js&"
export * from "./MgmManage.vue?vue&type=script&lang=js&"
import style0 from "./MgmManage.vue?vue&type=style&index=0&id=17be9d2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17be9d2e",
  null
  
)

export default component.exports